import { Field, Switch as SwitchChakra } from '@chakra-ui/react';

import { SwitchBaseLabelProps, SwitchComponentProps } from './switch.props';

export const Switch = ({
    id,
    labelLeft,
    labelRight,
    labelProps,
    name,
    checked,
    onChange,
    ...props
}: SwitchComponentProps): JSX.Element => {
    const BaseLabel = ({ label, textAlign, fontWeight, ...rest }: SwitchBaseLabelProps) => (
        <Field.Label
            {...labelProps}
            htmlFor={id}
            m={0}
            fontSize={'sm'}
            textAlign={textAlign}
            fontWeight={fontWeight}
            {...rest}
        >
            {label}
        </Field.Label>
    );

    return (
        <Field.Root
            display="flex"
            alignItems="center"
            flexDirection={'row'}
            justifyContent={'space-between'}
            gap={2}
            data-testid={'switch-wrapper'}
        >
            {labelLeft && (
                <BaseLabel data-testid={'switch-left-label'} label={labelLeft} textAlign={'end'} />
            )}
            <SwitchChakra.Root
                size="lg"
                id={id}
                name={name}
                onChange={onChange}
                checked={checked}
                {...props}
            >
                <SwitchChakra.HiddenInput />
                <SwitchChakra.Control>
                    <SwitchChakra.Thumb />
                </SwitchChakra.Control>
                {labelRight ? (
                    <SwitchChakra.Label asChild>
                        <BaseLabel data-testid={'switch-label'} label={labelRight} />
                    </SwitchChakra.Label>
                ) : null}
            </SwitchChakra.Root>
        </Field.Root>
    );
};
